import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "allowNegative", "numberOfDigits", "decimalScale", "className", "small"];
import "core-js/modules/es6.string.small.js";
import React from 'react';
import classnames from 'classnames';
import NumberFormat from 'react-number-format';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Input } from '../Input/Input';
import style from './FormattedInput.module.less';
/**
 * This type can be used to provide external-facing prop types for components
 * that compose `<FormattedInput>`. In those cases, we don't want to expose
 * all the `react-number-format` props externally - this interface does not
 * include the vast majority of them.
 */

/**
 * This is the base wrapper component that all
 * formatted inputs will compose.
 *
 * Note that this component shouldn't be used directly; similarly
 * to ActionBlock, consumers should rely on the exposed components
 * for what to use directly. For example, InputMoney.
 *
 * Note that the full set of react-number-props that are supported are at:
 *
 * https://github.com/s-yadav/react-number-format#props
 *
 */
export var FormattedInput = function FormattedInput(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$allowNegative = _ref.allowNegative,
      allowNegative = _ref$allowNegative === void 0 ? false : _ref$allowNegative,
      numberOfDigits = _ref.numberOfDigits,
      _ref$decimalScale = _ref.decimalScale,
      decimalScale = _ref$decimalScale === void 0 ? 2 : _ref$decimalScale,
      className = _ref.className,
      small = _ref.small,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedClassNameStylePropsWarning('Link', {
    className: className,
    style: otherProps.style
  });
  return /*#__PURE__*/React.createElement(NumberFormat, _extends({
    className: classnames(className, _defineProperty({}, style['small-input'], small)) // Limit the number of digits that the user can enter.
    // Examples:
    // a. if numberOfDigits = 3 and allowNegative is true:  valid range is (-10^3 ; floatValue ; 10^3).
    // b. if numberOfDigits = 5 and allowNegative is false: valid range is [0 ; floatValue ; 10^5).
    ,
    isAllowed: function isAllowed(values) {
      var floatValue = values.floatValue;

      if (numberOfDigits && floatValue) {
        // eslint-disable-next-line no-restricted-properties
        var maxValue = Math.pow(10, numberOfDigits);
        var minValue = -maxValue;

        if (allowNegative) {
          return floatValue > minValue && floatValue < maxValue;
        }

        return floatValue >= 0 && floatValue < maxValue;
      }

      return true;
    },
    customInput: Input,
    decimalScale: decimalScale,
    allowNegative: allowNegative,
    type: type
  }, otherProps));
};